export default {
    DATE_FROM: "От",
    DATE_TO: "До",
    AUTHOR: "Автор",
    WORKSPACE_AND_PROJECT: "Пространства и проекты",
    CANCEL_FILTER: "Отмена",
    APPLY_FILTER: "Применить",
    CLEAR_ALL: "Очистить все"
};
